export const ChannelConstant = [
  {
    name: 'all',
    label: 'ALL',
    icon: 'customer-insight-48',
    class: 'surf',
  },
  {
    name: 'facebook-messenger',
    label: 'FACEBOOK',
    icon: 'facebook-bg',
    class: 'chinese-blue',
  },
  {
    name: 'internal',
    label: 'INTERNAL',
    icon: 'people-working-together',
    class: 'dark-tangerine',
  },
  {
    name: 'direct',
    label: 'INSTAGRAM',
    icon: 'instagram-bg',
    class: 'vivid-cerise',
  },
  {
    name: 'whatsapp',
    label: 'WHATSAPP',
    icon: 'whats-app',
    class: 'apple',
  },
  {
    name: 'whatsapp-oficial',
    label: 'WHATSAPP_OFICIAL',
    icon: 'whatsapp-oficial-bg',
    class: 'apple',
  },
  {
    name: 'widget',
    label: 'WEBCHAT',
    icon: 'popup',
    class: 'purple-plum',
  },
  {
    name: 'telegram',
    label: 'TELEGRAM',
    icon: 'telegram',
    class: 'none-fill',
  },
  {
    name: 'email',
    label: 'EMAIL',
    icon: 'channel-mail',
    class: 'none-fill',
  },
  {
    name: 'linkedin',
    label: 'LINKEDIN',
    icon: 'linkedin',
    class: 'none-fill',
  },
  {
    name: 'ms-teams',
    label: 'MS_TEAMS',
    icon: 'ms-teams',
    // Brand asset is already multi-coloured; `none-fill` keeps its own palette
    // instead of flattening every path to a single channel colour.
    class: 'none-fill',
  },
];
